var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2350 4844 c-14 -2 -65 -9 -115 -15 -123 -15 -367 -78 -499 -129 -735 -285 -1270 -922 -1425 -1695 -29 -148 -41 -275 -41 -454 0 -605 240 -1181 670 -1611 337 -338 750 -552 1239 -641 140 -26 456 -36 612 -20 952 99 1743 774 1984 1696 51 193 66 299 72 512 8 257 -12 433 -73 663 -210 795 -846 1426 -1639 1628 -221 56 -359 72 -590 71 -93 -1 -181 -3 -195 -5z m333 -855 c430 -67 736 -482 667 -906 -91 -569 -721 -862 -1207 -563 -417 256 -508 823 -193 1195 183 215 455 317 733 274z m571 -1715 c161 -41 304 -159 375 -307 22 -45 67 -167 101 -271 71 -217 72 -242 13 -307 -44 -48 -95 -65 -155 -48 -77 20 -98 53 -168 264 -72 217 -86 250 -132 295 -72 72 -43 70 -726 70 -666 0 -647 2 -715 -56 -54 -45 -72 -82 -142 -294 -55 -166 -74 -211 -100 -236 -88 -89 -233 -47 -266 76 -11 43 -9 53 51 235 34 105 79 227 101 272 70 147 211 263 374 308 40 10 184 13 689 14 552 1 646 -1 700 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2441 3664 c-253 -68 -410 -331 -346 -579 67 -256 329 -415 580 -350 256 67 415 329 350 578 -67 259 -333 419 -584 351z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.d99a0ae973c186623af44ff8b2b9c0b4.svg";
export { ForwardRef as ReactComponent };